export const formatValue = (value: unknown): string => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value === "string" ||
    value === "null" ||
    value === "undefined"
  )
    return "-";
  return String(value).trim();
};
